<hb-modal-dialog id="confirm-dialog" [heading]="title" [showFooter]="false">
  <div content>
    <div *ngIf="showPrimaryAlert" class="alert alert-primary">
      {{ alertMessage }}
    </div>
    <p>{{ messageTop }}</p>
    <p *ngIf="messageBottom">{{ messageBottom }}</p>
  </div>
  <div footerContent>
    <button id="confirm-dialog-false" type="button" *ngIf="showCancel" class="btn btn-default pull-right" (click)="submit(false)">
      {{ negativeActionLabel }}
    </button>
    <button id="confirm-dialog-true" type="button" class="btn btn-primary" (click)="submit(true)">{{ affirmativeActionLabel }}</button>
  </div>
</hb-modal-dialog>
